/* ---------------------------------------------------------------------------
   "Choose options" on collection cards.

   Dawn's quick-add modal works by fetching the product page in the background
   and pulling out `section[id^="MainProduct-"]` to render inside a popup. P1's
   product pages do not have that section - they use the custom PDP section,
   which renders as `p1pdp-<id>`. So the fetch succeeds, the lookup returns
   null, and the modal opens with nothing in it. To a shopper the button simply
   does nothing, with no error and no navigation.

   Rather than rebuild the quick-add popup around a custom PDP, the button now
   does the honest thing and goes to the product page, where the pack options
   and add-to-cart already live.

   The listener is on `document` in the CAPTURE phase so it runs before the
   <modal-opener> element's own handler; stopPropagation then keeps the event
   from ever reaching it, so the empty modal never opens.
   --------------------------------------------------------------------------- */
(function () {
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var btn = target.closest('.quick-add__submit[data-product-url]');
      if (!btn) return;
      var url = btn.getAttribute('data-product-url');
      if (!url) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = url;
    },
    true
  );
})();
